import type { Connection, ConnectorListEntry } from "@tabbio/types";

// Shared launch gate: simplifying either UI must not enable unfinished tools.
export const TOOLS_COMING_SOON = true;
export const isActive = (connection: Connection | null) =>
  connection?.status === "active";
export const isComingSoon = (connector: ConnectorListEntry["connector"]) =>
  connector.status === "coming_soon" ||
  (TOOLS_COMING_SOON && connector.rail === "tool");
